/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { ContactDeliveryMethodIntMapper } from '../../contacts';
import { JobVariationStatus } from '../job-change-orders';
import { JobFinanceType } from '../job-general-info';
import {
  InvoicePhysicalType,
  InvoiceType,
  JobDrawCreateLendersScheduleRequestDto,
  JobDrawCreatePaymentScheduleRequestDto,
  JobDrawDetailsChangeOrderDto,
  JobDrawDetailsCurrentInvoiceDto,
  JobDrawDetailsDto,
  JobDrawDetailsInvoiceDto,
  JobDrawDetailsPaymentDto,
  JobDrawsDto,
  JobDrawsInvoiceDto,
  JobDrawsPaymentDto,
  DrawInvoiceStatus,
} from './job-draws.dto';

export const JobDrawsMapper = entity<JobDrawsDto>({
  invoices: arrayOf(subentity<JobDrawsInvoiceDto>({
    accountingDate: date(DateFormat.Date),
    type: enumeration(InvoiceType),
    status: enumeration(DrawInvoiceStatus),
    invoiceType: enumeration(InvoicePhysicalType),
    payments: arrayOf(subentity<JobDrawsPaymentDto>({
      paidDate: date(DateFormat.Date),
    })),
  })),
});

export const JobDrawChangeOrderMapper = entity<JobDrawDetailsChangeOrderDto>({
  authorizedDate: date(DateFormat.DateTime),
  status: enumeration(JobVariationStatus),
});

export const JobDrawDetailsMapper = entity<JobDrawDetailsDto>({
  customerMethod: ContactDeliveryMethodIntMapper,
  invoices: arrayOf(subentity<JobDrawDetailsInvoiceDto>({
    accountingDate: date(DateFormat.Date),
    type: enumeration(InvoiceType),
    invoiceType: enumeration(InvoicePhysicalType),
    payments: arrayOf(subentity<JobDrawDetailsPaymentDto>({
      paidDate: date(DateFormat.Date),
    })),
  })),
  invoice: subentity<JobDrawDetailsCurrentInvoiceDto>({
    accountingDate: date(DateFormat.Date),
  }),
  variations: arrayOf(JobDrawChangeOrderMapper),
  financeType: enumeration(JobFinanceType),
});

export const JobDrawCreateRequestMapper = entity<JobDrawCreatePaymentScheduleRequestDto>({
  accountingDate: date(DateFormat.Date),
  variations: arrayOf(JobDrawChangeOrderMapper),
});

export const JobDrawCreateLendersScheduleRequestMapper = entity<JobDrawCreateLendersScheduleRequestDto>({
  accountingDate: date(DateFormat.Date),
});
